import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm.js';
Swiper.use([Navigation, Pagination]);

import { fadeIn, fadeOut, throttle } from "../lib";

export default class PortfolioSection {
	constructor() {
		this.$root = document.getElementById('md-portfolio-section');
		this.$portfolioWorkCollection = this.$root.querySelectorAll('.md-portfolio-work');
		this.$portfolioMore = document.getElementById('md-portfolio-more');
		this.$collapse = this.$root.querySelector('.md-portfolio_collapse');
		this.$collpasedProjectCollection = this.$collapse.querySelectorAll('.md-portfolio_list-item');

		this.$modal = document.getElementById('md-portfolio-modal');
		this.$modalClose = this.$modal.querySelector('.md-portfolio-modal_close');
		this.$modalProjectLink = this.$modal.querySelector('.md-portfolio-modal_link');
		this.$modalContent = this.$modal.querySelector('.md-portfolio-modal_content');

		this.mode = this.$root.dataset.mode;
		this.mediaTablet = window.matchMedia('(max-width: 768px)').matches;

		this.sliderId = '#swiper-portfolio';
		this.slider = null;

		this.viewerOpened = false;
		this.moreShown = false;

		this.init();
	}

	init() {
		this.addListeners();

		if (this.mediaTablet && !this.slider) {
			this.initSlider();
		}
	}

	addListeners() {
		window.addEventListener('resize', throttle(() => {
			this.mediaTablet = window.matchMedia('(max-width: 768px)').matches;

			if (this.mediaTablet && !this.slider) {
				this.initSlider();
			}
		}, 25));

		this.$portfolioWorkCollection.forEach($item => {
			if (!$item.href && $item.dataset.projectUrl && $item.dataset.detailsSrc) {
				$item.addEventListener('click', e => {
					e.preventDefault();
					this.openViewer($item);
				});
			}
		});

		this.$portfolioMore.addEventListener('click', e => {
			e.preventDefault();

			if (!this.moreShown) {
				this.showMoreProjects();
			} else {
				this.hideMoreProjects();
			}

			this.moreShown = !this.moreShown;
		});

		window.addEventListener('keyup', e => {
			if (this.viewerOpened) {
				this.closeViewer();
			}
		})

		this.$modalClose.addEventListener('click', e => {
			e.preventDefault();
			this.closeViewer();
		});
	}

	initSlider() {
		const config = {
			slidesPerView: 1,
			spaceBetween: 15,
			pagination: {
				el: '.md-swiper-slider_pagination-container',
				clickable: true
			},
		};

		this.slider = new Swiper(this.sliderId, config);
	}

	openViewer($workLink) {
		const projectUrl = $workLink.dataset.projectUrl;
		const projectDetailsSrc = $workLink.dataset.detailsSrc;

		if (projectUrl === 'null') {
			this.$modalProjectLink.classList.add('-hidden');
		} else {
			this.$modalProjectLink.classList.remove('-hidden');
		}

		this.$modalProjectLink.setAttribute('href', projectUrl);
		this.$modalContent.querySelector('.md-portfolio-modal_work').remove();

		const view = this.setDetailsView(projectDetailsSrc);
		this.$modalContent.append(view);

		setTimeout(() => {
			fadeIn({
				$el: this.$modal,
				duration: 250
			});
			this.$modal.scrollTo(0, 0);
			scrollLock.disablePageScroll(this.$modal);
			this.viewerOpened = true;
		}, 50);
	}

	setDetailsView(src) {
		if (this.mode === 'behance') {
			const newImage = new Image();
			newImage.src = src;
			newImage.alt = 'Portfolio work screenshot';
			newImage.className = 'md-portfolio-modal_work';
			return newImage;
		} else {
			const iframe = document.createElement('iframe');
			iframe.src = src;
			iframe.className = 'md-portfolio-modal_work';
			return iframe;
		}
	}

	closeViewer() {
		this.$modal.style.display = 'none';
		scrollLock.enablePageScroll();
		this.viewerOpened = false;
	}

	showMoreProjects() {
		this.$portfolioMore.classList.add('-active');
		const rows = Math.ceil(this.$collpasedProjectCollection.length / 3);
		this.$collapse.style.maxHeight = rows * 240 + rows * 10 + 'px';

		this.$collpasedProjectCollection.forEach($item => {
			$item.classList.add('-shown');
		});
	}

	hideMoreProjects() {
		this.$collpasedProjectCollection.forEach($item => {
			$item.classList.remove('-shown');
		});

		this.$portfolioMore.classList.remove('-active');
		this.$collapse.style.maxHeight = 0;
	}
}
